import { createSlice } from "@reduxjs/toolkit";
import { AnnouncementResponseDto } from "../../shared/dtos/announcement/AnnouncementResponseDto";
import { AnnouncementSummaryDto } from "../../shared/dtos/announcement/AnnouncementSummaryDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const announcementSlice = createSlice({
  name: "announcement",
  initialState: getInitialCrudState<
    AnnouncementResponseDto,
    AnnouncementSummaryDto
  >(),
  reducers: {
    ...generateCrudReducers<AnnouncementResponseDto, AnnouncementSummaryDto>(),
  },
});

export const announcementActions = announcementSlice.actions;
export default announcementSlice.reducer;
